import { render, staticRenderFns } from "./AddPlatformStockCompareTemplateComponent.vue?vue&type=template&id=6b121d42&"
import script from "./AddPlatformStockCompareTemplateComponent.vue?vue&type=script&lang=js&"
export * from "./AddPlatformStockCompareTemplateComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports